import React, { useState, useEffect } from 'react';
import { fetchData, ADD_UPDATE_TERMS_CONDITIONS } from '../../components/Service'

const TermsOfUse = () => {
    window.document.title = "Terms of Use";

    const [terms, setTerms] = useState()

    useEffect(()=> {
        fetchData(ADD_UPDATE_TERMS_CONDITIONS, 'GET', '', false, false, (res) => {
            if (res.records) {
                let record = JSON.parse(res.records.value);
                setTerms(record)
            } else {
                setTerms('')
            }
        });
    }, [])

    return (
        <section className="py-5">
            { terms && Object.keys(terms) && Object.keys(terms).map((ele, num)=> {
                return(
                        <div className="container container-1180" key={num}>
                            <div className="row">
                                <div className="col-sm-12 mb-5">
                                {ele === 'Terms of Use' &&  terms[ele].text && <div dangerouslySetInnerHTML={{__html:terms[ele].text}}/>}
                                </div>
                            </div>
                        </div>
                    )
                 })}
        </section>
    )
}
export default TermsOfUse